import { useEffect, useState } from "react";
import { getAllStagesApi, createStageApi, updateStageApi, toggleStageApi, } from "../apiServices/stageServices";

const useStages = (filters = {}) => {
  const [stages, setStages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
  });

  const fetchStages = async () => {
    try {
      setLoading(true);

      const res = await getAllStagesApi(filters);

      setStages(res?.data?.stages || []);
      setPagination({
        page: res?.data?.page || 1,
        totalPages: res?.data?.totalPages || 1,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const createStage = async (data) => {
    await createStageApi(data);
    await fetchStages();
  };

  const updateStage = async (id, data) => {
    await updateStageApi(id, data);
    await fetchStages();
  };

  const toggleStage = async (id) => {
    await toggleStageApi(id);
    await fetchStages();
  };

  useEffect(() => {
    fetchStages();
  }, [JSON.stringify(filters)]);

  return { stages, loading, pagination, fetchStages, createStage, updateStage, toggleStage, };
};

export default useStages;